import styles from '@/styles/nav.module.scss';
import { useLocalization } from '@/hooks/useLocalization';
import { useWidget } from '@/state/WidgetContext';
import { SCREENS } from '@/utils/constants';

const BackIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></svg>
);
const MenuIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" /></svg>
);

export default function NavBar() {
  const { t } = useLocalization();
  const { state, goBack, goToMenu } = useWidget();

  const canGoBack = state.screenHistory.length > 0;
  const showMenu = state.screen !== SCREENS.WELCOME;

  if (!canGoBack && !showMenu) return null;

  return (
    <div className={styles.navBar}>
      <div className={styles.start}>
        {canGoBack && (
          <button className={styles.btn} onClick={goBack} type="button">
            <BackIcon />
            <span>{t('nav.back')}</span>
          </button>
        )}
      </div>
      <div className={styles.end}>
        {showMenu && (
          <button className={styles.btn} onClick={goToMenu} type="button">
            <MenuIcon />
            <span>{t('nav.menu')}</span>
          </button>
        )}
      </div>
    </div>
  );
}
